exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__IconRound__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n.DS__IconRound__root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  color: inherit;\n  cursor: inherit;\n  background-color: #ffffff;\n  border: 1px solid #eceff5;\n  border-radius: 50%;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__IconRound__root"
};